
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../_hooks/useAuthContext";
function useAssessmentHeader(props) {
  const navigate = useNavigate();

const {user} = useContext(AuthContext);

  const viewDashboardClick = () => {
    if (user?.user && user.user?.role === "mentor")
      navigate("/mentor-dashboard");
    else if (user?.user && user.user?.role === "candidate")
      navigate("/candidate-dashboard");
    else navigate("/hiring-manager-dashboard");
  };
  return {
    viewDashboardClick
  };
}
export default useAssessmentHeader;
